'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var protocol = exports.protocol = (typeof location === 'undefined' ? 'undefined' : _typeof(location)) === 'object' ? location.protocol : 'http:';


// WEBPACK FOOTER //
// ./src/api/constant.js